<div class="flex flex-col full-grow-no-shrink-no-basis">
  <div class="header-area flex flex-row justify-start items-center">
    <button
      (click)="openManageRoleDialog()"
      [disabled]="!(dynamicData.card?.permissionLevel === 310 || dynamicData.card?.permissionLevel === 320)"
      class="link-button"
      data-copilot="task-role-btn-add-role"
      mat-button
    >
      Add Role
    </button>
    <button
      (click)="openDynamicRoleDialog(false)"
      *ngIf="hasDynamicRole"
      [disabled]="!(dynamicData.card?.permissionLevel === 310 || dynamicData.card?.permissionLevel === 320)"
      class="link-button"
      data-copilot="task-role-btn-add-dynamic-role"
      mat-button
    >
      Add Dynamic Role
    </button>
  </div>

  <div class="content pos-relative flex flex-col full-grow-no-shrink-no-basis">
    <div class="keno-grid-container">
      <particle-virtual-grid
        (valueChanged)="onGridCellValueChange($event)"
        [invalidateSubject]="invalidateSubject"
        [parameters]="parameters"
        [sourceKey]="sourceKey"
        [serviceName]="serviceName"
        [api]="api"
        version="v2"
        tabStyle="compact"
        [useSwitchMap]="1===1">
      </particle-virtual-grid>
    </div>
  </div>
</div>
